module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-index"
  }, [_c('div', {
    staticClass: "grid-top"
  }, [_c('div', {
    staticClass: "grid-banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('van-swipe', {
    attrs: {
      "autoplay": 3000
    }
  }, _vm._l((_vm.adressData), function(item) {
    return _c('van-swipe-item', {
      key: item.bannerId
    }, [_c('a', {
      attrs: {
        "href": item.targetUrl
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageUrl(item.imageUrl)
      }
    })])])
  }))], 1)]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:96111"
    }
  }, [_c('svg', {
    staticClass: "icon tel",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    staticClass: "tel-img",
    attrs: {
      "xlink:href": "#icon-96111"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-line"
  }), _vm._v(" "), _c('GridCommon'), _vm._v(" "), _c('div', {
    staticClass: "bg-line"
  }), _vm._v(" "), _c('EduService'), _vm._v(" "), _c('div', {
    staticClass: "bg-line"
  }), _vm._v(" "), _c('QueryService'), _vm._v(" "), _c('div', {
    staticClass: "bg-line"
  }), _vm._v(" "), _c('HumanService'), _vm._v(" "), _c('div', {
    staticClass: "bg-line"
  }), _vm._v(" "), _c('GridFinance'), _vm._v(" "), (_vm.isShowNotice) ? _c('NoticeDialog', {
    attrs: {
      "show": _vm.isShowNotice
    },
    on: {
      "close": _vm.closeNotice
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf992b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/index.vue
// module id = 317
// module chunks = 40